import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propChildren } from '../../../../helpers/custom-prop-types';
const SlideSearchFilterContent = (props) => {
    const { children, icon, isShowBetaIcon, label } = props;
    return (_jsxs("div", Object.assign({ className: 'search_list_filter_body' }, { children: [_jsx("h4", Object.assign({ className: 'search_list_filter_body_title', role: 'presentation' }, { children: _jsxs("div", Object.assign({ className: 'search_list_filter_body_title_text_row' }, { children: [icon, _jsx("span", Object.assign({ className: 'search_list_filter_body_title_text' }, { children: label })), isShowBetaIcon && (_jsx("span", Object.assign({ className: 'search_list_filter_body_beta_icon' }, { children: "\u03B2\u7248" })))] })) })), children] })));
};
SlideSearchFilterContent.propTypes = {
    children: propChildren().isRequired,
    icon: propChildren().isRequired,
    isShowBetaIcon: propBool(),
    label: propChildren().isRequired,
};
SlideSearchFilterContent.defaultProps = {
    isShowBetaIcon: false,
};
export default SlideSearchFilterContent;
